import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { SignInfo } from 'domain-models/SignInfo';
import { environment } from '../../environments/environment';

@Injectable()
export class SignInfoService extends DataService<SignInfo> {
	constructor(http: Http) {
		super(environment.host + 'SignInfo', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/sign-info/sign-info.service.ts